import { render, staticRenderFns } from "./SoccerJoinMain.vue?vue&type=template&id=7957b513&scoped=true&"
import script from "./SoccerJoinMain.vue?vue&type=script&lang=js&"
export * from "./SoccerJoinMain.vue?vue&type=script&lang=js&"
import style0 from "./SoccerJoinMain.vue?vue&type=style&index=0&id=7957b513&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7957b513",
  null
  
)

export default component.exports